import { appId, appCode, getHereLangCode } from 'apis/here';

const ReactMapGlHereDarkTemplate = lang => {
  const langCode = getHereLangCode(lang);

  return {
    version: 8,
    name: 'HERE - Dark',
    provider: 'HERE',
    sources: {
      'here-map-base': {
        type: 'raster',
        tiles: [
          `https://1.base.maps.api.here.com/maptile/2.1/basetile/newest/normal.night/{z}/{x}/{y}/512/png8?app_id=${appId}&app_code=${appCode}`,
          `https://2.base.maps.api.here.com/maptile/2.1/basetile/newest/normal.night/{z}/{x}/{y}/512/png8?app_id=${appId}&app_code=${appCode}`,
          `https://3.base.maps.api.here.com/maptile/2.1/basetile/newest/normal.night/{z}/{x}/{y}/512/png8?app_id=${appId}&app_code=${appCode}`,
          `https://4.base.maps.api.here.com/maptile/2.1/basetile/newest/normal.night/{z}/{x}/{y}/512/png8?app_id=${appId}&app_code=${appCode}`
        ],
        minZoom: 1,
        maxZoom: 19,
        tileSize: 512
      },
      'here-map-labels': {
        type: 'raster',
        tiles: [
          `https://1.base.maps.api.here.com/maptile/2.1/labeltile/newest/normal.night/{z}/{x}/{y}/512/png8?app_id=${appId}&app_code=${appCode}&lg=${langCode}`,
          `https://1.base.maps.api.here.com/maptile/2.1/labeltile/newest/normal.night/{z}/{x}/{y}/512/png8?app_id=${appId}&app_code=${appCode}&lg=${langCode}`,
          `https://1.base.maps.api.here.com/maptile/2.1/labeltile/newest/normal.night/{z}/{x}/{y}/512/png8?app_id=${appId}&app_code=${appCode}&lg=${langCode}`,
          `https://1.base.maps.api.here.com/maptile/2.1/labeltile/newest/normal.night/{z}/{x}/{y}/512/png8?app_id=${appId}&app_code=${appCode}&lg=${langCode}`
        ],
        minZoom: 1,
        maxZoom: 19,
        tileSize: 512
      }
    },
    layers: [{
      id: 'here-map-base',
      type: 'raster',
      source: 'here-map-base'
    }, {
      id: 'here-map-labels',
      type: 'raster',
      source: 'here-map-labels'
    }],
    thumbnailUrl: '/img/base-layer-thumbnails/dark-map-thumbnail.jpg'
  };
};

export default ReactMapGlHereDarkTemplate;
